export default __webpack_public_path__ + "static/media/png.09ddab1b.svg";